import { render, staticRenderFns } from "./InformativoCoamo.vue?vue&type=template&id=4b0227ae&scoped=true&lang=pug"
import script from "./InformativoCoamo.vue?vue&type=script&lang=js"
export * from "./InformativoCoamo.vue?vue&type=script&lang=js"
import style0 from "./InformativoCoamo.styl?vue&type=style&index=0&id=4b0227ae&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0227ae",
  null
  
)

export default component.exports